import { ToothMark } from "./Logo";

export default function Marquee({ words }) {
    const row = (key) => (
        <div key={key} className="flex shrink-0 items-center">
            {words.map((w, i) => (
                <span key={`${key}-${i}`} className="flex items-center">
                    <span className="whitespace-nowrap px-8 font-serif text-2xl font-normal italic text-ink/70 sm:text-3xl">
                        {w}
                    </span>
                    <ToothMark className="h-5 w-5 opacity-70" />
                </span>
            ))}
        </div>
    );

    return (
        <div
            data-testid="editorial-marquee"
            className="marquee overflow-hidden border-y border-line bg-white py-6"
            aria-hidden="true"
        >
            <div className="marquee-track flex w-max">
                {row("a")}
                {row("b")}
            </div>
        </div>
    );
}
